export const sortAlphabets = (items) => {
    if (items.length > 0) {
        return items.sort((a, b) => (a.name > b.name ? 1 : -1));
    }
    return [];
};
